import React from 'react';
import { Skeleton, SkeletonSquare, SkeletonRound } from '@fiverr-private/feedback';
import { Stack } from '@fiverr-private/layout_components';

export const ReviewsSkeleton = () => (
    <Skeleton>
        <Stack gap="5">
            <SkeletonRound size="32px" />
            <Stack direction="column" gap="2">
                <Stack gap="3">
                    <SkeletonSquare width="100px" height="22px" />
                    <SkeletonSquare width="100px" height="22px" />
                    <SkeletonSquare width="80px" height="22px" />
                </Stack>
                <SkeletonSquare width="834px" height="50px" />
                <SkeletonSquare width="90px" height="21px" />
            </Stack>
        </Stack>
    </Skeleton>
);
